import React from "react";

/**
 * Componente de loading spinner reutilizável
 * @param {string} size - Tamanho do spinner: 'sm', 'md', 'lg' (padrão: 'md')
 * @param {string} message - Mensagem opcional a ser exibida
 * @param {boolean} fullPage - Se true, ocupa a página inteira
 * @param {string} color - Cor do spinner (padrão: 'var(--color-primary)')
 */
const LoadingSpinner = ({
  size = "md",
  message = "Carregando...",
  fullPage = false,
  color = "var(--color-primary)",
}) => {
  const sizeValues = {
    sm: 40,
    md: 60,
    lg: 80,
  };

  const spinnerSize = sizeValues[size];

  const containerClass = fullPage
    ? "loading-container-fullpage"
    : "loading-container";

  const styles = {
    spinnerWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "16px",
    },
    spinner: {
      width: spinnerSize,
      height: spinnerSize,
      position: "relative",
    },
    ring: {
      position: "absolute",
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      border: `${spinnerSize / 12}px solid transparent`,
      borderTopColor: color,
      animation: "spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite",
    },
    ring2: {
      position: "absolute",
      width: "75%",
      height: "75%",
      top: "12.5%",
      left: "12.5%",
      borderRadius: "50%",
      border: `${spinnerSize / 14}px solid transparent`,
      borderTopColor: color,
      opacity: 0.7,
      animation: "spin 1s cubic-bezier(0.5, 0, 0.5, 1) infinite reverse",
    },
    ring3: {
      position: "absolute",
      width: "50%",
      height: "50%",
      top: "25%",
      left: "25%",
      borderRadius: "50%",
      border: `${spinnerSize / 16}px solid transparent`,
      borderTopColor: color,
      opacity: 0.5,
      animation: "spin 0.8s cubic-bezier(0.5, 0, 0.5, 1) infinite",
    },
    dot: {
      position: "absolute",
      width: spinnerSize / 6,
      height: spinnerSize / 6,
      backgroundColor: color,
      borderRadius: "50%",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      animation: "pulse 1.2s ease-in-out infinite",
    },
  };

  return (
    <div className={containerClass}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes pulse {
            0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
            50% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.6; }
          }
        `}
      </style>
      <div className="loading-content">
        <div style={styles.spinnerWrapper}>
          <div style={styles.spinner}>
            <div style={styles.ring}></div>
            <div style={styles.ring2}></div>
            <div style={styles.ring3}></div>
            <div style={styles.dot}></div>
          </div>
          {message && <p className="loading-message">{message}</p>}
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
